var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2.83374,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#19B361"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6251 14.0798L15.1864 9.16604C15.3856 8.9532 15.655 8.83374 15.9359 8.83374C16.2168 8.83374 16.4863 8.9532 16.6855 9.16604C16.7852 9.27227 16.8643 9.39865 16.9182 9.53791C16.9722 9.67716 17 9.82652 17 9.97737C17 10.1282 16.9722 10.2776 16.9182 10.4168C16.8643 10.5561 16.7852 10.6825 16.6855 10.7887L11.3694 16.5023C11.1713 16.7134 10.904 16.8325 10.6251 16.8337C10.4852 16.8346 10.3465 16.8058 10.2169 16.7489C10.0874 16.692 9.96957 16.6082 9.87022 16.5023L7.37164 13.8055C7.26034 13.7031 7.16995 13.577 7.10613 13.4352C7.04231 13.2935 7.00645 13.139 7.00079 12.9817C6.99514 12.8243 7.01981 12.6673 7.07326 12.5207C7.12672 12.3741 7.2078 12.2409 7.31141 12.1295C7.41503 12.0182 7.53894 11.931 7.67538 11.8736C7.81182 11.8161 7.95784 11.7896 8.10426 11.7957C8.25069 11.8018 8.39437 11.8403 8.52627 11.9089C8.65818 11.9775 8.77548 12.0746 8.87079 12.1943L10.6251 14.0798Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkDark);
export default __webpack_public_path__ + "static/media/checkmark-dark.f94a385ce57af8c0db3019e3a443603b.svg";
export { ForwardRef as ReactComponent };